<script>
import resources from './resources'

export default {
  name: 'professional-schedulings-preview',

  mixins: [resources]
}
</script>

<template lang="pug">
  div
    .row
      div.col-xs-12.col-sm-10.col-sm-offset-1
        h4 AGENDAMENTOS
          span(v-html="title")
        table.table.table-fixed.table-hover
          thead
            tr
              th.col-xs-2 #
              th.col-xs-2 Data
              th.col-xs-2 Hora
              th.col-xs-2 Dia da semana
          tbody
            tr(v-for="(schedule, index) in schedules", :key="schedule.id")
              td.col-xs-1
                input(type="checkbox", v-model="schedule.lock")
              td.col-xs-1 {{ schedule.date }}
              td.col-xs-1 {{ schedule.time }}
              td.col-xs-1 {{ schedule.day }}

        .buttons-wrapper
          button.btn.exclude.disabled(@click.prevent="doRemoves()", v-if="!isValid")
            span.icon &#xE913;
            |Remover Selecionados

          button.btn.exclude(@click.prevent="doRemoves()", v-if="isValid")
            span.icon &#xE913;
            |Remover Selecionados

          button.btn.cancel(@click.prevent="doDeleteAll(rule)")
            span.icon &#xE911;
            |Cancelar

          button.btn.save(@click.prevent="doPublish(rule)")
            span.icon &#xE911;
            |Publicar Agenda
</template>



// WEBPACK FOOTER //
// src/app/professional/schedulings/preview/schedules.vue